module.exports = __webpack_public_path__ + "static/media/about-slide-img-3.fd7dafb9.svg";